import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withKeys as _withKeys, createTextVNode as _createTextVNode, unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 查询");

const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 重置");

const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 新增 ");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("删除");

const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 编辑 ");

import { ref, watch, computed } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { getVexTableProps } from '@/config';
import { getRoleList, delRole } from '@/request';
import { useStore } from 'vuex';
import AddRoleModal from './component/AddRoleModal.vue';
export default {
  name: 'RoleManage',

  setup(__props) {
    const store = useStore();
    const userType = computed(() => store.state.user.userType);
    const roleType = userType.value === 1 ? 2 : 1;
    const form = ref({
      roleName: '',
      roleType
    });

    function initForm(source = {
      roleName: '',
      roleType
    }) {
      form.value = _objectSpread({}, source);
    }

    const table = ref();
    const showAddRoleModal = ref(false);
    const editData = ref(null);
    const formRef = ref();
    const tableOptions = getVexTableProps({
      columns: [{
        type: 'checkbox',
        width: '50px'
      }, {
        field: 'roleName',
        title: '角色名称'
      }, {
        title: '角色描述',
        field: 'roleDesc'
      }, {
        title: '创建时间',
        field: 'createAt'
      }, {
        title: '操作',
        field: 'operation',
        fixed: 'right',
        slots: {
          default: 'operation'
        }
      }],
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      },
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getRoleList(_objectSpread({
              page: page.currentPage,
              rows: page.pageSize
            }, form.value)).then(data => {
              res({
                total: data.total,
                result: data.rows
              });
            });
          })
        }
      }
    });

    function search() {
      table.value.commitProxy('reload');
    }

    function reset() {
      initForm();
      table.value.commitProxy('reload');
    } // 弹窗关闭 清空需要编辑的数据


    watch(() => showAddRoleModal.value, newVal => {
      if (!newVal) {
        editData.value = null;
      }
    });

    function delRows() {
      const selectRows = table.value.getCheckboxRecords();

      if (!selectRows.length) {
        ElMessage({
          showClose: true,
          message: '请勾选角色后再进行删除!',
          type: 'warning'
        });
        return;
      }

      console.log(selectRows);
      ElMessageBox.confirm(`是否确认删除${selectRows.length}条数据`, {
        title: '删除'
      }).then(() => {
        delRole({
          manager: 1,
          ids: selectRows.map(role => role.roleId).join(','),
          __repeat: true,
          __warn: true
        }).then(data => {
          if (data.success) {
            ElMessage({
              showClose: true,
              message: '操作成功!',
              type: 'success'
            });
            search();
          }
        });
      });
    }

    function addSuccess() {
      table.value.commitProxy('reload');
    }

    function edit({
      roleId,
      menuIds,
      roleName,
      roleDesc
    }) {
      editData.value = {
        roleId,
        menuIds,
        roleName,
        roleDesc
      };
      showAddRoleModal.value = true;
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_row = _resolveComponent("el-row");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_form, {
        inline: true,
        onKeydown: _cache[1] || (_cache[1] = _withKeys($event => table.value.commitProxy('reload'), ["enter"]))
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "角色名"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.value.roleName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.roleName = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        justify: "end"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          icon: "Search",
          onClick: search
        }, {
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          icon: "Refresh",
          onClick: reset
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_vxe_grid, _mergeProps({
        ref_key: "table",
        ref: table
      }, _unref(tableOptions)), {
        tools: _withCtx(() => [_createVNode(_component_el_button, {
          icon: "Plus",
          type: "primary",
          onClick: _cache[2] || (_cache[2] = $event => showAddRoleModal.value = true)
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        }), _createVNode(_component_el_button, {
          icon: "Delete",
          type: "danger",
          onClick: delRows
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        })]),
        operation: _withCtx(({
          row
        }) => [_createVNode(_component_el_button, {
          type: "primary",
          icon: "Edit",
          onClick: $event => edit(row)
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 2
        }, 1032, ["onClick"])]),
        _: 1
      }, 16), _createVNode(AddRoleModal, {
        modelValue: showAddRoleModal.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => showAddRoleModal.value = $event),
        editData: editData.value,
        onSuccess: addSuccess
      }, null, 8, ["modelValue", "editData"])]);
    };
  }

};